module.exports = __webpack_public_path__ + "media/1_7.057efa2f.wav";